export const utils = {
    formatNumber: (data) => {
        let value = (data).toLocaleString(
            undefined,
            // { minimumFractionDigits: 2 }
            // rajoute ,00 a la fin 10000 = 10 000,00
        );
        return value;
    },
    triggerSpinner: () => {
        $('.triggerspinner').click(function () {
            $('#overlay').fadeIn();
        });
    },
    numberWithSpaces: (x) => {
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        return parts.join(".");
    },
}